import { CheckClientHeader } from '../constants'

/**
 * Headers of a check online payment request. Its background worker's status
 * polls send them too, since the status endpoint checks the same client
 */
function getCheckOnlinePaymentHeaders(
  correlationId: string,
  virtualPOSClientId: string,
) {
  return {
    'x-channel': 'pos',
    'x-correlation-id': correlationId,
    client: CheckClientHeader,
    clientid: virtualPOSClientId,
  }
}

export default getCheckOnlinePaymentHeaders
